// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import OneTimeDownload from "entity/OneTimeDownload";
import Paging from "./Paging";
import SocialRecording, { processSocialRecording, processSocialRecordingArray } from "entity/SocialRecording";

import { QueryParams, RestController, RestRequest } from "./RestController";

export default class RecordingController extends RestController {

    createOneTimeDownload(socialRecordingId: string): Promise<OneTimeDownload> {
        let request = new RestRequest("/api/v1/recording/download/" + socialRecordingId + "", "POST", null, undefined);
        return this.request(request, null) as Promise<OneTimeDownload>;
    }

    deleteRecording(socialRecordingId: string): Promise<void> {
        let request = new RestRequest("/api/v1/recording/" + socialRecordingId + "", "DELETE", null, undefined);
        return this.requestVoid(request);
    }

    failedRecording(recordingId: string): Promise<void> {
        let request = new RestRequest("/api/v1/recording/failed", "POST", null, { recordingId: recordingId });
        return this.requestVoid(request);
    }

    getCompanyRecordings(text?: string, page?: Paging): Promise<SocialRecording[]> {
        const queryParams: QueryParams = { };
        if (text !== undefined) {
          queryParams.text = text;
        }
        let request = new RestRequest("/api/v1/recording/company", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialRecordingArray) as Promise<SocialRecording[]>;
    }

    getMyRecordings(text?: string, page?: Paging): Promise<SocialRecording[]> {
        const queryParams: QueryParams = { };
        if (text !== undefined) {
          queryParams.text = text;
        }
        let request = new RestRequest("/api/v1/recording/mine", "GET", null, queryParams);
        if (page) request.addPaging("", page);

        return this.request(request, processSocialRecordingArray) as Promise<SocialRecording[]>;
    }

    getRecording(recordingId: string): Promise<SocialRecording> {
        let request = new RestRequest("/api/v1/recording", "GET", null, { recordingId: recordingId });
        return this.request(request, processSocialRecording) as Promise<SocialRecording>;
    }

    processRecording(recording: SocialRecording): Promise<SocialRecording> {
        let request = new RestRequest("/api/v1/recording/processing", "POST", recording, undefined);
        return this.request(request, processSocialRecording) as Promise<SocialRecording>;
    }

    saveRecording(recording: SocialRecording): Promise<SocialRecording> {
        let request = new RestRequest("/api/v1/recording/save", "POST", recording, undefined);
        return this.request(request, processSocialRecording) as Promise<SocialRecording>;
    }

}
